<form [formGroup]="form">
  <div class="options-block-container">
    @for (element of elementsList(); track element) {
      @let isActive = form.get('contentType')?.value === element.value;
      <input
        type="radio"
        [id]="element.value"
        [value]="element.value"
        formControlName="contentType"
      />
      <label [for]="element.value" [ngClass]="{ active: isActive, disabled: disabled() }">
        <span class="radio"></span>
        <kin-icon [color]="isActive ? textColor : textColor500" [name]="element.icon" />
        <div>
          <p class="mode-title">{{ element.title | translate | upperFirstLetter }}</p>
          <p class="advice">{{ element.subTitle | translate | upperFirstLetter }}</p>
        </div>
      </label>
    }
  </div>
</form>
